import _store from "store2";

import {ElMessage} from "element-plus";
import {i18n} from "@/lang";
import {getMailProductList, getProductDetail} from "@/api/usercenter";
import {useRoute} from "vue-router";
import {computed} from "vue";
import {useStore} from "vuex";
import {spaceSizeFormat} from "@/utils/file";
import {Storage} from "@/utils/storage"
import sessionStore from "@/utils/sessionStore";

function safeParseJSON(raw, fallback) {
    if (!raw) return fallback
    try {
        return JSON.parse(raw)
    } catch (e) {
        return fallback
    }
}

function getCurrentUserId() {
    try {
        const localUserInfo = safeParseJSON(localStorage.getItem('userInfo'), null)
        const storeUserInfo = Storage.get('userInfo')
        const userInfo = localUserInfo || storeUserInfo || {}
        const userId = userInfo?.id ?? userInfo?.userID
        return userId === undefined || userId === null ? '' : String(userId)
    } catch (e) {
        return ''
    }
}

function getScopedStorageKey(baseKey) {
    const userId = getCurrentUserId()
    return userId ? `${baseKey}_${userId}` : ''
}

function readScopedStorage(baseKey, fallback) {
    const storageKey = getScopedStorageKey(baseKey)
    if (!storageKey) return fallback
    return safeParseJSON(localStorage.getItem(storageKey), fallback)
}

function writeScopedStorage(baseKey, value) {
    const storageKey = getScopedStorageKey(baseKey)
    if (!storageKey) return
    localStorage.setItem(storageKey, JSON.stringify(value))
}

const buystorage = {
        namespaced: true,
        state: {
            // 数据源
            vbxData: [],
            checkOutData: [],
            // 选中的data
            selectTargetData: [],
            //选中的目标
            checkIndex: 1,
            // 选择的数量
            num: 1,
            //     所有商品列表
            allProductList: readScopedStorage("allProductList", []),
            allUserVip: readScopedStorage("allUserVip", []),
            // 所有的
            allProductListSort: [],
            // 选中的
            selectTargetProduct: readScopedStorage("selectTargetProduct", {}),
            existingValueVip: readScopedStorage('existingValueVip', 0),
            vipUpsellPrice: safeParseJSON(localStorage.getItem('vipUpsellPrice'), null),
            upsellVipChecked: readScopedStorage('upsellVipChecked', false),
            rowTable: sessionStore.get("rowTable") ?? []
        },
        getters: {
            allProductListSortAll(state) {
                // product_sort（商品分类(1：团队工位包，2：空间包，3：营销EDM包，4：AI点书包，5：免费会员，6：铜级会员,，7：银级会员，8：金级会员））
                return [...state.allProductList, ...state.allUserVip];
            },
            //计算总价格
            sumPrice: (state, getters, rootState, rootGetters) => {
                const {productPrice, productCheapPrice} = state.selectTargetProduct
                const isVipUser = rootGetters['user/isVipUser'] // ✅ 正确方式获取其他模块的 getter
                const targetProduct = state.selectTargetProduct || {}
                console.log(targetProduct, 'isVip')
                const useMemberPrice = isVipUser || targetProduct?.productSort > 5 || state.upsellVipChecked
                const unitPrice = useMemberPrice ? (productCheapPrice ? productCheapPrice : 0) : (productPrice ? productPrice : 0)
                const isBuyingVip = Number(state.selectTargetProduct?.id) === 9 || Number(state.selectTargetProduct?.productSort) === 9
                const upsellFee = Number(state.vipUpsellPrice ?? 188)
                const vipFee = (!isVipUser && state.upsellVipChecked && !isBuyingVip) ? (Number.isFinite(upsellFee) ? upsellFee : 0) : 0
                return ((unitPrice * state.num) + vipFee).toFixed(2);
            },
            // 计算原价
            sumUnPrice: (state, getters, rootState, rootGetters) => {
                const {productPrice, productCheapPrice} = state.selectTargetProduct
                const isVipUser = rootGetters['user/isVipUser'] // ✅ 正确方式获取其他模块的 getter
                const isBuyingVip = Number(state.selectTargetProduct?.id) === 9 || Number(state.selectTargetProduct?.productSort) === 9
                const upsellFee = Number(state.vipUpsellPrice ?? 188)
                const vipFee = (!isVipUser && state.upsellVipChecked && !isBuyingVip) ? (Number.isFinite(upsellFee) ? upsellFee : 0) : 0
                const result = (productPrice ? productPrice : 0)
                return ((result * state.num) + vipFee).toFixed(2);
            },
            // 优惠价格
            Discountedprices: (state, getters, rootState, rootGetters) => {
                const {productPrice, productCheapPrice} = state.selectTargetProduct
                const isVipUser = rootGetters['user/isVipUser']
                const original = (productPrice ? productPrice : 0) * state.num
                const member = (productCheapPrice ? productCheapPrice : 0) * state.num
                const diff = original - member

                // 用户本身已是会员（包含“永久免费”），会员优惠应仅为会员价差
                if (isVipUser) {
                    return (diff > 0 ? diff : 0).toFixed(2)
                }

                // 非会员：未勾选加购会员时，沿用接口返回的 cheapMoney（existingValueVip）
                if (!state.upsellVipChecked) {
                    return ((state.existingValueVip || 0) * 1).toFixed(2)
                }

                // 非会员：勾选加购会员时，优惠 = 会员价差 + existingValueVip
                return ((diff > 0 ? diff : 0) + (state.existingValueVip || 0) * 1).toFixed(2);
            },
            sumPriceVbx: (state) => {
                const res = state.vbxData.filter(
                    (item) => item.isSelect
                );
                if (res.length !== 0) {
                    const {productPrice} = res[0];
                    return ((productPrice ? productPrice : 0) * state.num).toFixed(2);
                }
            },
            // 计算原价
            sumUnPriceVbx: (state) => {
                const res = state.vbxData.filter(
                    (item) => item.isSelect
                );
                if (res.length !== 0) {
                    const {productPrice} = res[0];
                    return ((productPrice ? productPrice : 0) * state.num).toFixed(2);
                }
            },
            // 优惠价格
            DiscountedpricesVbx:
                (state) => {
                    const res = state.vbxData.filter(
                        (item) => item.isSelect
                    );
                    if (res.length !== 0) {
                        const {productPrice, productCheapPrice} = res[0];
                        return ((productPrice ? productPrice : 0) * state.num - (productCheapPrice ? productCheapPrice : 0) * state.num).toFixed(2);
                    }
                },
        },
        mutations: {
            setRowTable(state, payload) {
                state.rowTable = payload
                sessionStore.set('rowTable', payload)
            },
            setVipUpsellPrice(state, payload) {
                const n = Number(payload)
                state.vipUpsellPrice = Number.isFinite(n) && n >= 0 ? n : state.vipUpsellPrice
                localStorage.setItem('vipUpsellPrice', JSON.stringify(state.vipUpsellPrice))
            },
            // 设置检查索引
            setCheckIndex(state, index) {
                state.checkIndex = index;
            }
            ,
            // 更新数据源
            setCheckOutData(state, data) {
                state.checkOutData = data;
            }
            ,
            // 更新会员数据
            setvbxData(state, data) {
                state.vbxData = data;
            }
            ,
            // 更新数量
            setNum(state, payload) {
                state.num = payload;
            }
            ,
            setUpsellVipChecked(state, payload) {
                state.upsellVipChecked = !!payload
                writeScopedStorage('upsellVipChecked', state.upsellVipChecked)
            },
        }
        ,
        actions: {
            //获取商品列表
            async getMailProductListApis({state}, payload) {
                const res = await getMailProductList({type: payload});
                if (res.code !== 200) {
                    ElMessage.error(res.message);
                    return
                }
                if (payload === 1) {
                    state.allProductList = res.result;
                    writeScopedStorage("allProductList", res.result)
                } else if (payload === 2) {
                    // 重新添加用户权益数据
                    let targetList = res.result.map(item => {
                        let parsedRemark = {}
                        try {
                            parsedRemark = item?.remark ? JSON.parse(item.remark) : {}
                        } catch (e) {
                            parsedRemark = {}
                        }
                        const safeRemark = parsedRemark && typeof parsedRemark === 'object' ? parsedRemark : {}
                        const {workPositionNum, locationNum, edmNum, aiNum, isCheap} = safeRemark
                        return {
                            ...item,
                            totalPosition: workPositionNum,
                            effectiveLocation: spaceSizeFormat(locationNum),
                            edmTotalNum: edmNum,
                            totalAiNum: aiNum,
                            isCheap
                        }
                    })
                    state.allUserVip = targetList;
                    writeScopedStorage("allUserVip", targetList)
                }
            }
            ,
            async getVipUpsellPrice({commit}) {
                const res = await getProductDetail({id: 9})
                if (res.code !== 200) {
                    ElMessage.error(res.message);
                    return
                }
                const price = res?.result?.data?.productPrice
                commit('setVipUpsellPrice', price)
            },
            // 获取善品列表详情
            async getProductDetailApis({commit, state, getters}, payload) {
                const res = await getProductDetail(payload)
                if (res.code !== 200) {
                    ElMessage.error(res.message);
                    return
                }
                const allData = getters.allProductListSortAll;
                const findTarget = allData.find(item => item.productSort === res.result.data.productSort)
                console.log(allData, 'allData')
                state.selectTargetProduct = {...findTarget, isSelect: true};
                writeScopedStorage("selectTargetProduct", state.selectTargetProduct)

                // 现有会员 价值
                state.existingValueVip = res.result?.cheapMoney ?? 0
                writeScopedStorage('existingValueVip', res.result.cheapMoney ?? 0)
            }
        },
    }
;

export default buystorage;
